import axios from 'axios';
import store from '../redux/store/store';
import { Password } from '@mui/icons-material';
import { CC_API_BASE_URL, getCcRequestConfig } from '../config/ccApiConfig';
const API_MARKETPLACES_URL = import.meta.env.VITE_API_URL;

const marketplacesService = {

 
//Market hesap bilgilerini getirir 
getMarketPlacesAccountsApi: (userId,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.get(`${API_MARKETPLACES_URL}/MarketPlaceSetting?UserId=${userId}`,{
    headers: {
      Authorization: `Bearer ${userToken}`},
    });
},


// //Market hesap bilgilerini getirir 
// getMarketPlacesAccountsApi: async (userId, token) => {
//   try {
//     const response = await axios.get(`${API_MARKETPLACES_URL}/MarketPlaceSettings?UserId=${userId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("API error:", error.response ? error.response.data : error.message);
//   }
// },

//Marketleri getir 
getMarketPlacesApi: async (token) => {
  try {
    
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const response = await axios.get(`${API_MARKETPLACES_URL}/MarketPlace`,{
      headers: {
        Authorization: `Bearer ${userToken}`,},
      }); 
     
    return response; 

  } catch (error) {
    console.error("market bilgileri alınırken bir hata oluştu:", error);
    throw error;  
  }
},
//market bilgisi ekle
addMarketPlaceApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  const postData = data.marketplaceData.map((item) => ({
    UserId: 1,
    MarketPlaceId: item.marketplaceId,
    ValueId: item.valueId,
    Value: item.value,
    IA:true
  }));

 
  
  return axios.post(
    `${API_MARKETPLACES_URL}/MarketPlaceSetting/CreateRange`, 
    postData,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
},

//market bilgisi GÜNCELLE
updateMarketPlaceApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  const postData = data.marketplaceData.map((item) => ({
    userId: item.appUserId,
    marketplaceId: item.marketplaceId,
    valueId: item.valueId,
    value: item.value,
    id:item.id,
  }));
  
  return axios.put(`${API_MARKETPLACES_URL}/MarketPlaceSetting/UpdateRange`, postData,{
    headers: {
      Authorization: `Bearer ${userToken}`,},
    });
},
getMarketPlcesForCC: () => {
  return axios.get(`${CC_API_BASE_URL}/MarketPlace`, getCcRequestConfig());
},
};
export default marketplacesService;
